export const PATH_ROOT = "/";
export const PATH_LOGOUT = "/logout";
export const PATH_LOGOUT_SUCCESS = "/logoutsuccess";
export const PATH_ENROLL_COMPLETED = "/enrollconfirm";